module.exports = __webpack_public_path__ + "static/media/img103.25b6d0ce.png";